// Vendors
import React, { createContext, useContext, useState } from 'react';
// Enumerations
import { ProofIncomeStatesEnumeration } from '../enumerations/proof-income-states.enumeration';
import { ProofIncomeMethodsEnumeration } from '../enumerations/proof-income-methods.enumeration';
// Types
import { ProofIncomeContextType } from './types/proof-income-landing.contexts.type';

const ProofIncomeContext = createContext<ProofIncomeContextType>({} as ProofIncomeContextType);

const ProofIncomeContextProvider = ({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement => {
  const [proofIncomeState, setProofIncomeState] = useState<ProofIncomeStatesEnumeration>(
    ProofIncomeStatesEnumeration.LANDING
  );
  const [selectedMethod, setSelectedMethod] = useState<ProofIncomeMethodsEnumeration>(
    '' as ProofIncomeMethodsEnumeration
  );
  const [iframeUrl, setIframeUrl] = useState('');
  const [proofIncomeIdentificationId, setProofIncomeIdentificationId] = useState('');

  return (
    <ProofIncomeContext.Provider
      value={{
        iframeUrl,
        proofIncomeIdentificationId,
        proofIncomeState,
        selectedMethod,
        setIframeUrl,
        setProofIncomeIdentificationId,
        setProofIncomeState,
        setSelectedMethod,
      }}
    >
      {children}
    </ProofIncomeContext.Provider>
  );
};

const useProofIncomeContextConsumerHook = (): ProofIncomeContextType =>
  useContext(ProofIncomeContext);

/* eslint-disable */
const ProofIncomeContextConsumerHOC =
  (Component: React.FunctionComponent<any>): React.FunctionComponent<any> =>
  (props: any): React.ReactElement<React.Provider<any>> =>
    (
      <ProofIncomeContextProvider>
        <Component {...props} />
      </ProofIncomeContextProvider>
    );

export {
  useProofIncomeContextConsumerHook,
  ProofIncomeContextConsumerHOC,
  ProofIncomeContextProvider,
};
